<template>
    <div class="raw-html" :class="{ 'raw-html-plain': schema.noBorder }">
        <div v-if="schema.html" v-html="formattedValue"></div>
        <pre v-else-if="schema.lang" v-text="formattedValue"></pre>
        <div v-else v-text="formattedValue"></div>
    </div>

</template>

<script>
  import {abstractField} from "vue-form-generator";

  export default {
    mixins: [abstractField],
    computed: {
      formattedValue() {
        if (this.schema.formatter) {
          return this.schema.formatter(this.value, this.model, null, this.schema);
        }
        return this.value;
      }
    }
  };
</script>
<style lang="scss">
    .raw-html {
        border: 1px solid #e7e7e7;
        padding: 5px;
        max-height: 300px;
        overflow: auto;

        &.raw-html-plain {
            display: flex;
            align-items: center;
            border: none;
            font-size: 13px;
            height: 45px;
            max-height: none;
            overflow: visible;
            border-bottom: 1px solid #e7e7e7;
            margin: 0.375rem;
            padding: 0 1rem;
        }
    }
</style>